import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div``;
const Heading = styled.h3`
  font-weight: 700;
  color: ${COLORS.BLACK};
  font-size: 16px;
  margin: 5px 0 10px 0;
`;
export { Container, Heading };
